export default __webpack_public_path__ + "static/media/image.visiro-global-solutions-pvt-ltd.d7870c4d.png";